import Pattern from "../../assets/HeadingSectionPattern.svg"
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { GetAllCategories } from "../../api/Categories/GetAllCategories";
const CoursesHeader = () => {
  const [searchParams] = useSearchParams();
  const { data: CategoriesDTO } = useQuery({
    queryFn: GetAllCategories,
    queryKey: ["categories"],
    staleTime: 0,
    refetchInterval: 0,
  });

  const categoryParam = searchParams.get('category');
  const selectedCategory = categoryParam
    ? CategoriesDTO?.data?.find(
      cat => cat.name.toLowerCase() === decodeURIComponent(categoryParam).toLowerCase()
    )
    : null;

  return (
    <div className="bg-[#c7461f] relative md:h-[435px] sm:h-[400px] h-[360px] md:mt-20 mt-[60px]">
      <img src={Pattern} className="absolute w-full h-full md:object-cover" alt="" />
      {selectedCategory && (
        <>
          <div className="absolute w-full h-full md:object-cover bg-black/50 z-50" />
          <img src={selectedCategory.img_url} className="absolute w-full h-full md:object-cover" alt="" />
        </>
      )}
      <div className="container z-50 relative h-full flex items-center justify-center ">
        <div className="w-full text-white text-center">
          <h1 className="font-semibold lg:text-5xl md:text-4xl sm:text-3xl text-2xl mb-1.5">
            {selectedCategory
              ? `Explore ${selectedCategory.name} Courses`
              : "Explore Courses That Drive Your Potential"
            }
          </h1>
          <p className="mb-8 md:text-lg sm:text-base text-sm max-w-4xl mx-auto">
            {selectedCategory
              ? `${selectedCategory.description}`
              : "Discover our curated courses designed to equip you with the skills, knowledge, and confidence to excel in today's competitive world."
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoursesHeader;
